/**
 * Класс банкомата на карте
 */
export class CompanyMapData {

    public CompanyId: number = 0;

    public Type: string = '';

    public Adress: string = '';

    public Cords: Array<string> = [];

    public City: string = '';

    public WorkingTime: string = '';

    public Country: string = '';

    public Street: string = '';

    public AdressName: string = '';

    public Email: string = '';

    public DeviceNumber: string = '';

    public Options: string = '';
  
  
    /**
     * Конструктор с загрузкой данных с сервера.
     * @param src Источник данных.
     */
    public constructor(src: any = null) {
      if (src) {
        this.CompanyId = src.CompanyId ?? 0;
        this.Type = src.Type ?? '';
        this.Adress = src.Adress ?? '';
        this.Cords = src.Cords ?? [];
        this.City = src.City ?? '';
        this.WorkingTime = src.WorkingTime ?? '';
        this.Country = src.Country ?? '';
        this.Street = src.Street ?? '';
        this.AdressName = src.AdressName ?? '';
        this.Email = src.Email ?? '';
        this.DeviceNumber = src.DeviceNumber ?? '';
        this.Options = src.Options ?? '';
      }
    }
}
  